import withDddDetail from "../withDddDetail"
import DddFinalDisinfectionForm from "./DddFinalDisinfectionForm"
import DddFinalDisinfectionPDFGenerator from "./DddFinalDisinfectionPDFGenerator"

const dddFormKazakhName = 'Қорытынды дезинфекцияға берілетін НАРЯД'
const dddFormName = 'НАРЯД на заключительную дезинфекцию'
const dddName = 'DddFinalDisinfection'

export default withDddDetail(DddFinalDisinfectionForm, DddFinalDisinfectionPDFGenerator, dddFormKazakhName, dddFormName, dddName)
